import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { Tab } from "react-bootstrap";
import AppCli from "./AppCli";
import AppTr from "./AppTr";
import AppPlay from './AppPlay';

import * as FcIcons from "react-icons/fc";

import './styles.css';

const Apps = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [location.pathname]);

    const [activeTab, setActiveTab] = useState('/appcli');

    const handleTabSelect = (selectedTab) => {
        setActiveTab(selectedTab);
    };

    return (
        <div className='tab-menu'><br />
            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                <Nav fill variant="tabs" defaultActiveKey="/appcli">
                    <Nav.Item>
                        <Nav.Link eventKey="/appcli">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcTwoSmartphones /></h4>
                                <h5>App Cliente</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/appplay">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcTwoSmartphones /></h4>
                                <h5>App Gigabyte Play</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/apptr">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcTwoSmartphones /></h4>
                                <h5>App TR-069</h5>
                            </div>                            
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <br />
                    <Tab.Pane eventKey="/appcli">
                        <AppCli />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/appplay">
                        <AppPlay />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/apptr">
                        <AppTr />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
}
export default Apps;